import PasswordResetSubmit from "../Components/Login/PasswordResetSubmit";

const PasswordResetSubmitPage = () => {
  return <PasswordResetSubmit />;
};

export default PasswordResetSubmitPage;
